import { FlexContainer } from "../Container/FlexContainer";
import { CFlexContainer } from "../Container/CFlexContainer";
import { Container } from "../Container/Container";
import { Radio } from "./Radio";
import { Label } from "./Label";

export class RadioGroup extends FlexContainer {

    public addRadios(radios: any[]): void {
        radios.forEach((rd: { r: any, l: any }) => {
            this.addRadio(rd.r, rd.l);
        });
    }

    public addRadio(radio: any, label: any): void {
        const c = new CFlexContainer();
        const radioEl = new Radio(radio);
        radioEl.onChange((_e: Event) => { this.onRadioChange(radio); });

        c.appendChild(radioEl);
        c.appendChild(new Label(label));
        const c2 = new Container();
        c2.appendChild(c);
        this.appendChild(c2);
    }

    protected initialize(data: any) {
        super.initialize(data);
        this.spaceAround();
        const radios = this.get("radios");
        if (radios) {
            this.addRadios(radios);
        }
    }

    private onRadioChange(e: any): void {
        const func = this.get("onRadioChange");
        if (func instanceof Function) { func(e); }
    }
}
